import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { AccessResult } from "utils/access";

import { showDeleteConfirmation } from "./DeleteConfirmation";

type StackSettingsIntegrationsWebhooksDropdownProps = {
  onEditClick: () => void;
  onDetailsClick: () => void;
  canManageStack: AccessResult;
  endpoint: string;
  id: string;
  refetchQueriesOnDelete?: string[];
  stackId: string;
};

const StackSettingsIntegrationsWebhooksDropdown = ({
  onEditClick,
  refetchQueriesOnDelete,
  endpoint,
  id,
  stackId,
  onDetailsClick,
  canManageStack,
}: StackSettingsIntegrationsWebhooksDropdownProps) => {
  const handleDeleteClick = () => {
    showDeleteConfirmation({ endpoint, id, refetchQueriesOnDelete, stackId });
  };

  return (
    <DropdownMenuEllipsis tooltip="Webhook actions">
      <DropdownMenuItem onAction={onDetailsClick}>Details</DropdownMenuItem>
      {(canManageStack.result || !!canManageStack.message) && (
        <DropdownMenuItem
          onAction={onEditClick}
          isDisabled={!canManageStack.result}
          tooltip={canManageStack.message}
        >
          Edit
        </DropdownMenuItem>
      )}
      {(canManageStack.result || !!canManageStack.message) && (
        <DropdownMenuItem
          onAction={handleDeleteClick}
          danger
          isDisabled={!canManageStack.result}
          tooltip={canManageStack.message}
        >
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default StackSettingsIntegrationsWebhooksDropdown;
